/**
 * Enrutamiento de eventos PostHog a dos proyectos:
 * - Psicólogo: UAT o Prod según entorno (siempre)
 * - Paciente: solo en prod, via proxy
 *
 * Un evento va al cliente psicólogo si:
 * - properties.userType === 'practitioner', o
 * - el nombre del evento está en PRACTITIONER_ONLY_EVENT_NAMES (vistas que no pasan por practitionerAnalytics)
 */
export const PRACTITIONER_ONLY_EVENT_NAMES = new Set([
  'LoginPractitionerView',
  'clickLoginPractitionerSubmit',
  'clickLoginPractitionerGoogle',
  'clickLoginPractitionerForgotPassword',
  'SubscriptionUpdateFlowDetected',
  'SubscriptionUpdateAlreadyCompleted',
  'SubscriptionUpdateButtonShown',
  'AccountView',
  'AccountViewFirstTime',
  'ProfilePractitionerView',
  'TrackingView',
  'CommunityView',
  'ChatPsicologistView',
  'clickSendMessageCommunitySpecialist',
  'clickSendMessageChatSpecialist',
  'clickSendMessageToPatient',
  'ResourceReviewQuestionnaireView',
  'ResourceReviewChatbotView',
  'ResourceReviewVideoView',
  'ResourceReviewIAView',
  'clickResourceReviewBack',
  'PacientsView',
  'clickPacientsSearch',
  'clickPacientsRowOpen',
  'clickPacientsFilterOrganization',
  'clickPacientsClearFilters',
  'PatientDetailView',
  'clickPatientDetailBack',
  'clickPatientDetailOpenAgenda',
  'clickPatientDetailOpenAssistant',
  'clickPatientDetailTab',
  'UnifiedProfileView',
  'clickUnifiedProfileTab',
  'clickUnifiedProfileOpenAssistant',
  'clickUnifiedProfileOpenResource',
  'ProgramConfigurationView',
  'clickProgramConfigAddDiagnostic',
  'clickProgramConfigDeleteObjective',
  'ProfilePatientView',
  'clickProfilePatientBack',
  'ScoringView',
  'AlertsView',
  'clickAlertsMarkAllRead',
  'clickAlertsFilterPriority',
  'clickAlertsAlertSelect',
  'clickAlertsOpenChat',
  'clickAlertsOpenAgenda',
  'clickAlertsToggleStatus',
  'clickAlertsPagePrev',
  'clickAlertsPageNext',
  'clickAlertsPageNumber',
  'clickAlertsRetry',
  'TasksView',
  'clickTasksOpenTask',
  'clickTasksCompleteTask',
  'AssistantView',
  'clickAssistantSendMessage',
  'clickAssistantQuickQuestion',
]);

/** InitialScreenView con loginType practitioner se considera psicólogo (se decide por propiedades, no por nombre) */
export function isPractitionerEvent(eventName, properties = {}) {
  if (properties.userType === 'patient') return false;
  if (properties.userType === 'practitioner') return true;
  if (PRACTITIONER_ONLY_EVENT_NAMES.has(eventName)) return true;
  if (eventName === 'InitialScreenView' && (properties.loginType === 'practitioner' || properties.role === 'SPECIALIST' || properties.role === 'SUPERVISOR')) return true;
  return false;
}

export function isPractitionerRole(role) {
  return role === 'SPECIALIST' || role === 'SUPERVISOR';
}
